export default {"src":"/_next/static/media/search.c05f9316.svg","height":24,"width":24};